import { cloneDeep } from 'lodash';
import {
  GameState,
  PlayerState,
  PlayerStateFull,
  TeamStateFull
} from '../../types/state';
import { putToStore } from '../indexedDB';
import { GameContextState } from '../../contexts/game';
import { TeamContextState } from '../../contexts/team';
import { PlayerContextState } from '../../contexts/player';
import { GetResourceValue } from '../game-document/resources';
import { GameDocumentState } from '../../contexts/game-document';

/**
 * Update player state indexedDB.
 * @param playerState - The playerstate
 * @param updated - The updated playerstate
 * @constructor
 */
export const UpdatePlayerStateAsync = (
  playerState: PlayerContextState,
  updated: PlayerStateFull
) => {
  const result = cloneDeep({
    ...playerState,
    playerState: cloneDeep({ ...updated })
  });
  putToStore('player-state', result);
  return result;
};
/**
 * Update Game player state.
 * @param gamePlayerState - The updated gameplayer
 * @constructor
 */
export const UpdateGamePlayerStateAsync = (
  gamePlayerState: PlayerState,
  isDirty: boolean = true
) => {
  return { ...gamePlayerState, isDirty };
};

/**
 * Update game state indexedDB.
 * @param game - The GameContextState
 * @param updated - The updated GameState
 * @returns updated Promise<GameContextState>
 * @constructor
 */
export const UpdateGameStateAsync = (
  game: GameContextState,
  updated: GameState
) => {
  const result = cloneDeep<GameContextState>({
    ...game,
    gameState: cloneDeep({ ...updated })
  });
  putToStore('game-state', result);
  return result;
};

/**
 * Update team state indexedDB.
 * @param game - The TeamContextState
 * @param updated - The updated TeamState
 * @param isDirty - Update teamContextState isDirty status
 * @returns updated Promise<TeamContextState>
 * @constructor
 */
export const UpdateTeamStateAsync = (
  team: TeamContextState,
  updated: TeamStateFull
) => {
  const result = cloneDeep<TeamContextState>({
    ...team,
    teamState: cloneDeep({ ...updated })
  });
  putToStore('team-state', result);
  return result;
};

export const GetGameLogo = (
  gameDocument: GameDocumentState,
  player: PlayerContextState
): string => {
  if (gameDocument.gameDocument!.overview!.logoResId! === '') {
    return '../../cg-icon-globe.svg';
  } else {
    const gameImage = GetResourceValue(
      gameDocument.gameDocument!,
      gameDocument.gameDocument!.overview!.logoResId!,
      player?.playerState?.language?.name! ?? ''
    );
    return gameImage;
  }
};

export const GetGameName = (
  gameDocument: GameDocumentState,
  player: PlayerContextState
): string => {
  const titleRes = GetResourceValue(
    gameDocument.gameDocument!,
    gameDocument.gameDocument!.overview!.titleResId!,
    player?.playerState?.language?.name! ?? ''
  );
  return titleRes;
};
